// const { Space, Form, Input } = require("antd");
import styled from "styled-components"
import { Space, Form, Input, Divider, Button, Checkbox, Modal, Table } from "antd"
import { forwardRef, useEffect, useState } from "react"
import axios from "axios"
import createImagePromptGPT from "./controller/createImagePromptGPT";

const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
`;

const StyledSpace = styled((props)=><Space direction="vertical" size={0} {...props}/>)`
  &&& {
    display: flex;
    flex-direction: column;
    flex-grow:1;
    overflow: auto;

    & > .ant-space-item {
      overflow: auto;
    }

    .new-word-prompt label {
      width: 100%;
    }
  }
`
const backend = process.env.REACT_APP_BACKEND
const start = process.env.REACT_APP_VARIABLE_START
const end = process.env.REACT_APP_VARIABLE_END

function ImageTabRightPromptNewCondition ({prompt, rightBox, stateHandler, promptDataHandler, gptModel}, promptRef) {
  const [sourceData, setSourceData] = useState([])
  const [isVariableCondition, SetIsVariableCondition] = useState(false)
  const [compareCondition, setCompareCondition] = useState(true)
  const [statements, setStatements] = useState([false, null, {}])
  const [meaningPrompt, setMeaningPrompt] = useState(rightBox[1].meaning_prompt)
  const [backgroundPrompt, setBackgroundPrompt] = useState(rightBox[1].background_prompt)
  const [finalPromptSentence, setFinalPromptSentence] = useState("")
  const [rightBoxId, setRightBoxID] = useState(null)

  const columns = [
    {
      title: "프롬프트 문장",
      dataIndex: "statement_text",
      width: 200,
      // render: (_,record)=>_ ? <div>{(_/record.total*100).toFixed(1)+"%"}</div> : null
    },
    {
      title: "선택",
      dataIndex: "",
      width: 50,
      render: (_)=><a onClick={()=>choicePromptStatementHandler(_)}>선택</a>
    },
  ]

  const choicePromptStatementHandler = (_) => {
    const newData = sourceData.slice(0)
    const num = statements[1]
    newData[num].statement_text = _.statement_text
    newData[num].variable_default_value = _.variable_default_value
    promptDataChangeHandlerAll2(newData, num)
    setStatements([false,null,{}])
  }

  function promptDataChangeHandlerAll (data) {    
    const newData = data.map(el=>{
      const text = el.statement_text
      let variableArray = []
      let textArray = []

      //배치할 텍스트와 변수를 배열로 정렬하는 재귀함수
      const variableF = (text) =>{
        // const text = String(textValue)
        if(text === null || text === undefined) return
        const a = text.indexOf(start)
        let b = -1

        // 어느 위치의 변수가 빠졌는지 확인하는 재귀함수
        const bFunction = (text) => {
          if(text.indexOf(end) === -1) return
          if(text.indexOf(end) > a) {
            b=text.indexOf(end)
            return
          }
          const subText = text.replace(end,"a")
          bFunction(subText)
        }
        bFunction(text)

        // const b = text.indexOf(end)
        if(a === -1 || b === -1) {
          textArray.push(text)
          return
        }

        const variableText = text.substring(a+1,b) // 변수
        const preText = text.slice(0,a) // 변수 전의 텍스트
        variableArray.push(variableText)
        // variableUseYnArray.push("Y")
        textArray.push(preText)
        const nextText = text.slice(b+1) // 변수 후의 나머지 텍스트
        variableF(nextText)
      }
      variableF(text)

      const big = Math.max(el.statement_variable_array.length, variableArray.length)
      
      if(el.statement_variable_array.length > variableArray.length) { // 변수가 제외되는 경우
        const a = JSON.parse(JSON.stringify(el.statement_variable_array))
        const b = JSON.parse(JSON.stringify(variableArray))
        for (let i=0; i<big; i++) {
          if(a[i] === b[i]) {
            continue;
          } else {
            b.splice(i,0,"")
            el.variableArray.splice(i,1)
            el.statement_variable_useyn.splice(i,1)
          }
        }
      } else if(el.statement_variable_array.length < variableArray.length) { // 변수가 추가되는 경우
        const a = JSON.parse(JSON.stringify(el.statement_variable_array))
        const b = JSON.parse(JSON.stringify(variableArray))
        for (let i=0; i<big; i++) {
          if(a[i] === b[i]) {
            continue;
          } else {
            a.splice(i,0,"")
            el.variableArray.splice(i,0,"")
            el.statement_variable_useyn.splice(i,0,"Y")
          }
        }
      }

      el.statement_variable_array = variableArray
      el.statement_text_array = textArray

      el.prompt_text = el.statement_variable_array.length === 0 ? (el.statement_text && el.statement_text) : promptFuntion(el)
      return el
    })
    setSourceData(newData)
    promptDataHandler(newData)

  }

  function promptDataChangeHandlerAll2 (data, num) {    
    
    const source = data.map((el,idx)=>{
      if(idx !== num) return el
      const text = el.statement_text

      let variableArray = []
      let textArray = []
      let variableUseYnArray = []

      const variableF = (text) =>{
        // const text = String(textValue)
        if(text === null || text === undefined) return
        const a = text.indexOf(start)
        const b = text.indexOf(end)
        if(a === -1 || b === -1) {
          textArray.push(text)
          return
        }
        const variableText = text.substring(a+1,b) // 변수
        const preText = text.slice(0,a) // 변수 전의 텍스트
        variableArray.push(variableText)
        variableUseYnArray.push("Y")
        textArray.push(preText)
        const nextText = text.slice(b+1) // 변수 후의 나머지 텍스트
        variableF(nextText)
      }
      variableF(text)
      
      el.useYn = "Y"
      el.statement_variable_useyn = variableUseYnArray
      el.statement_variable_array = variableArray
      el.statement_text_array = textArray
      el.variableArray = el.variable_default_value?.split(",").map(el=>el.trim()) || []
      el.prompt_text = el.statement_variable_array.length === 0 ? (el.statement_text && el.statement_text) : promptFuntion(el)
      return el
    })
    setSourceData(source)
    promptDataHandler(source)
  }

  const promptFuntion = (el) => {
    let prompt = ""
    for(let i=0; i<el.statement_variable_array.length; i++){
      prompt = prompt + el.statement_text_array[i] + (el.statement_variable_useyn[i] === "Y" ? (el.variableArray[i] || `${start}${el.statement_variable_array[i] || ""}${end}`) : `${start}${el.statement_variable_array[i] || ""}${end}`)
    }
    if(el.statement_variable_array.length < el.statement_text_array.length) {
      prompt += el.statement_text_array[el.statement_variable_array.length]
    }
    return prompt
  }

  const getSourceData = () => {
    axios.get(`${backend}/contents/new_word/image/new-prompt`)
    .then(res=>{
      const promptData = JSON.parse(JSON.stringify(res.data.data[1]))
      const source = promptData.map(el=>{
        const text = 
          el.id === 1
          ? rightBox[1].meaning_prompt
          : el.id === 2
          ? rightBox[1].background_prompt
          : el.statement_text
  
        let variableArray = []
        let textArray = []
        let variableUseYnArray = []
  
        const variableF = (text) =>{
          // const text = String(textValue)
          if(text === null || text === undefined) return
          const a = text.indexOf(start)
          let b = -1
  
          // 어느 위치의 변수가 빠졌는지 확인하는 재귀함수
          const bFunction = (text) => {
            if(text.indexOf(end) === -1) return
            if(text.indexOf(end) > a) {
              b=text.indexOf(end)
              return
            }
            const subText = text.replace(end,"a")
            bFunction(subText)
          }
          bFunction(text)
  
          // const b = text.indexOf(end)
          if(a === -1 || b === -1) {
            textArray.push(text)
            return
          }
          const variableText = text.substring(a+1,b) // 변수
          const preText = text.slice(0,a) // 변수 전의 텍스트
          variableArray.push(variableText)
          variableUseYnArray.push("Y")
          textArray.push(preText)
          const nextText = text.slice(b+1) // 변수 후의 나머지 텍스트
          variableF(nextText)
        }
        variableF(text)
        
        el.useYn = "Y"
        el.statement_variable_useyn = variableUseYnArray
        el.statement_variable_array = variableArray
        el.statement_text_array = textArray
        el.variableArray = el.variable_default_value?.split(",").map(el=>el.trim()) || []
        el.prompt_text = el.statement_variable_array.length === 0 ? (text && text) : promptFuntion(el)
        el.statement_text = text

        return el
      })

      setSourceData(source)
      promptDataHandler(source)
    })
    .catch(err=>{
      console.log(err)
    })
    .finally(()=>{
    })
  }

  const getStructure = () => {
    return (
      <Space direction="vertical" size="small" style={{ width: "100%", marginBottom:20 }}>
      {sourceData.map((el,idx)=>
        (el.id === 1 || el.id === 2)
        ?
          <Space key={idx} direction="vertical" style={{width:"100%"}}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <Checkbox 
                  checked={el.useYn === "Y" ? true : false}
                  onChange={()=>{promptUseYnHandler(idx)}}
                >
                  {el.prompt_name}
                </Checkbox>
              </div>
              <Button size="small" onClick={el.id === 1 ? ()=>{createMeaningPrompt(idx)} : ()=>{createBackgroundPrompt(idx)}}>프롬프트 생성</Button>
            </div>
            {
              el.statement_variable_array.length && el.useYn === "Y"
              ?
              el.statement_variable_array.map((ele,idx2)=>
                <Space key={idx2} direction="vertical" style={{width:"100%"}}>
                  <div style={{ display: "flex", justifyContent: "left", marginLeft:40 }}>
                    <Checkbox 
                      checked={el.statement_variable_useyn[idx] === "Y" ? true : false}
                      onChange={()=>{statementUseYnHandler(idx, idx2)}}
                    >
                      {ele}
                    </Checkbox>
                  </div>
                  <div style={{marginLeft:40}}>
                    <Input size="small" value={el.variableArray[idx2]} onChange={(e)=>{statementVariableChangeHandler(idx,idx2,e)}}></Input>
                  </div>
                </Space>
              ) : null
            }
            <Input.TextArea 
              autoSize
              value={el.statement_text} 
              // value={el.id === 1 ? meaningPrompt : backgroundPrompt}
              disabled = {el.useYn === "Y" ? false : true}
              // onChange={(e)=>el.id === 1 ? meaningPromptChangeHandler(idx,e) : backgroundPromptChangeHandler(idx,e)}
              // onBlur={(e)=> el.id ===1 ? meaningPromptBlurHandler(idx,e) : backgroundPromptBlurHandler(idx,e)}
              onChange={(e)=>statementTextChangeHandler(idx, e)}
              onBlur={(e)=>statementTextBlurHandler(idx,e)}
            >
            </Input.TextArea>
            <Input.TextArea
                autoSize
                disabled
                style={{color:"black"}}
                // value={el.id === 1 ? rightBox[1].meaning_prompt : rightBox[1].background_prompt}
                value={el.prompt_text}
              >
              </Input.TextArea>

            <div style={{ display: "flex", justifyContent: "left" }}>
              <Button size="small" style={{ marginRight: 10 }} onClick={()=>{upHandler(idx)}}>위로</Button>
              <Button size="small" onClick={()=>{downHandler(idx)}}>아래로</Button>
            </div>
            <Divider />
          </Space>

          :
          <Space key={idx} direction="vertical" style={{width:"100%"}}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <Checkbox 
                checked={el.useYn === "Y" ? true : false}
                onChange={()=>{promptUseYnHandler(idx)}}
              >
                {el.prompt_name}
              </Checkbox>
            </div>
            <Button size="small" onClick={()=>{promptSentenceChangeHandler(idx, el.id)}}>문장 변경</Button>
          </div>
          {
            el.statement_variable_array.length && el.useYn === "Y"
            ?
            el.statement_variable_array.map((ele,idx2)=>
              <Space key={idx2} direction="vertical" style={{width:"100%"}}>
                <div style={{ display: "flex", justifyContent: "left", marginLeft:40 }}>
                  <Checkbox 
                    checked={el.statement_variable_useyn[idx2] === "Y" ? true : false}
                    onChange={()=>{statementUseYnHandler(idx, idx2)}}
                  >
                    {ele}
                  </Checkbox>
                </div>
                <div style={{marginLeft:40}}>
                  <Input size="small" value={el.variableArray[idx2]} onChange={(e)=>{statementVariableChangeHandler(idx,idx2,e)}}></Input>
                </div>
              </Space>
            ) : null
          }
          <Input.TextArea 
            autoSize
            value={el.statement_text} 
            disabled = {el.useYn === "Y" ? false : true}
            onChange={(e)=>statementTextChangeHandler(idx, e)}
            onBlur={(e)=>statementTextBlurHandler(idx,e)}
          >
          </Input.TextArea>
          <Input.TextArea
              autoSize
              disabled
              style={{color:"black"}}
              value={el.prompt_text}
            >
            </Input.TextArea>

          <div style={{ display: "flex", justifyContent: "left" }}>
            <Button size="small" style={{ marginRight: 10 }} onClick={()=>{upHandler(idx)}}>위로</Button>
            <Button size="small" onClick={()=>{downHandler(idx)}}>아래로</Button>
          </div>
          <Divider />
        </Space>
      )}
      </Space>
    )
  }

  const upHandler = (id) =>{
    const newData = sourceData.slice(0)
    if(id === 0) {
      return
    }

    newData[id].order = newData[id].order -1
    newData[id-1].order = newData[id-1].order +1

    const orderedData = newData.sort((a,b)=>a.order-b.order)

    setSourceData(orderedData)
    promptDataHandler(orderedData)
    }

  const downHandler = (id) => {
      const newData = sourceData.slice(0)
      if(id === newData.length -1) {
        return
      }

      newData[id].order = newData[id].order +1
      newData[id+1].order = newData[id+1].order -1
      const orderedData = newData.sort((a,b)=>a.order-b.order)

      setSourceData(orderedData)
      promptDataHandler(orderedData)
  }

  const promptSentenceChangeHandler = (num,id) => {
    axios
    .get(`${backend}/contents/new_word/image/new-prompt/${id}`)
    .then(res=>{
      setStatements([true,num,res.data.data])
    })
    .catch(err=>{
      console.log(err);
    })
  }

  const promptUseYnHandler = (id)=>{
    const newData = sourceData.slice(0)
    newData[id].useYn = newData[id].useYn === "Y" ? "N" : "Y"
    promptDataChangeHandler(newData)
  }
  const statementUseYnHandler = (id,idx)=>{
    const newData = sourceData.slice(0)
    newData[id].statement_variable_useyn[idx]= newData[id].statement_variable_useyn[idx] === "Y" ? "N" : "Y"
    promptDataChangeHandler(newData)
  }
  function promptDataChangeHandler (data) {    
    const newData = data.map(el=>{
      el.prompt_text = el.statement_variable_array.length === 0 ? (el.statement_text && el.statement_text) : promptFuntion(el)
      return el
    })
    setSourceData(newData)
    promptDataHandler(newData)
  }

  const statementTextChangeHandler = (id, e) => {
    const value = e.target.value
    const newData = sourceData.slice(0)
    newData[id].statement_text = value
    promptDataChangeHandler(newData)
  }
  const statementTextBlurHandler = (id, e) => {
    const value = e.target.value
    const newData = sourceData.slice(0)
    newData[id].statement_text = value

    promptDataChangeHandlerAll(newData)
  }
  const meaningPromptChangeHandler = (id, e) => {
    console.log(sourceData)
    const value = e.target.value
    setMeaningPrompt(value)
  }
  const meaningPromptBlurHandler = (id, e) => {
    const value = e.target.value
    const instance = {...rightBox[1]}
    instance.meaning_prompt = value
    stateHandler("sourceDataForRightBox", instance)
  }
  const backgroundPromptChangeHandler = (id, e) => {
    const value = e.target.value
    setBackgroundPrompt(value)
  }
  const backgroundPromptBlurHandler = (id, e) => {
    const value = e.target.value
    const instance = {...rightBox[1]}
    instance.background_prompt = value
    stateHandler("sourceDataForRightBox", instance)
  }

  const statementVariableChangeHandler = (id,idx,e) => {
    const value = e.target.value
    const newData = sourceData.slice(0)
    newData[id].variableArray[idx] = value
    promptDataChangeHandler(newData)
  }

  const finalPromptSentenceHandler = () => {
    if(sourceData.length) {
      const promptSentence = sourceData.reduce((acc,cur)=>{
        if(!cur.prompt_text || cur.useYn === "N") return acc
        if(acc === "") {
          acc += cur.prompt_text
        } else {
          acc += "\n"+cur.prompt_text
        }
        return acc
      },"")
      promptRef.current.setFieldValue("prompt_text", promptSentence)
      setFinalPromptSentence(promptSentence)
    }
  }

  const compareF = () => {
    const curFinalPromptSentence = promptRef.current.getFieldValue("prompt_text") || ""
    const a = curFinalPromptSentence.indexOf(start)
    let b = -1

    // 어느 위치의 변수가 빠졌는지 확인하는 재귀함수
    const bFunction = (text) => {
      if(text.indexOf(end) === -1) return
      if(text.indexOf(end) > a) {
        b=text.indexOf(end)
        return
      }
      const subText = text.replace(end,"a")
      bFunction(subText)
    }
    bFunction(curFinalPromptSentence)

    if(a === -1 || b === -1) {
      SetIsVariableCondition(true)
    } else {
      SetIsVariableCondition(false)
    }

    const promptSentence = sourceData.reduce((acc,cur)=>{
      if(!cur.prompt_text || cur.useYn === "N") return acc
      if(acc === "") {
        acc += cur.prompt_text
      } else {
        acc += "\n"+cur.prompt_text
      }
      return acc
    },"")
    
    if(JSON.stringify(curFinalPromptSentence) === JSON.stringify(promptSentence)) {
      setCompareCondition(true)
    } else {
      setCompareCondition(false)
    }
  }

  const createMeaningPrompt = (id) => {
    const record = rightBox[1]
    if(!record.translate_text) {
      Modal.error({
        title: "에러",
        content: "단어의 해석이 없으면 프롬프트를 생성할 수 없습니다.",
        okText: "확인"
      })
      return
    }

    const meaningPrompt_1 = prompt.meaningPrompt.replace(/{word_en}/gi,record.word)
    const meaningPrompt = meaningPrompt_1.replace(/{word_ko}/gi,record.translate_text)
    stateHandler("loading", true)
    createImagePromptGPT(meaningPrompt, gptModel.gpt_model)
    .then(newPrompt=>{
      let onlyPrompt = newPrompt
      if(newPrompt[0] === `"`) {
        onlyPrompt = newPrompt.slice(1,-1)
      }
      const value = {
        id: record.dalle_id,
        WordExMaster_id: record.id,
        meaning_prompt: onlyPrompt
      }
      axios.post(`${backend}/contents/new_word/image/meaning_prompt`,{value})
      .then(res=>{
        const instance = {...record}
        instance.meaning_prompt = onlyPrompt
        instance.dalle_id = res.data.data
        stateHandler("sourceDataForRightBox", instance)
        stateHandler("rightBox", [true, instance])
        
        const newData = sourceData.slice(0)
        newData[id].statement_text = onlyPrompt
        promptDataChangeHandlerAll(newData)
      })
      .catch(err=>{
        console.log(err)
        Modal.error({
          title:"에러",
          okText:"확인",
          content:"서버 에러가 발생해서 프롬프트를 생성하지 못했습니다."
        })
      })
    })
    .catch(err=>{
      console.log(err)
      Modal.error({
        title:"에러",
        okText:"확인",
        content:"AI 에러가 발생해서 프롬프트를 생성하지 못했습니다."
      })
    })
    .finally(()=>{
      stateHandler("loading", false)
    })
  }

  const createBackgroundPrompt = (id) => {
    const record = rightBox[1]
    if(!record.translate_text) {
      Modal.error({
        title: "에러",
        content: "단어의 해석이 없으면 프롬프트를 생성할 수 없습니다.",
        okText: "확인"
      })
      return
    }

    const backgroundPrompt = prompt.backgroundPrompt.replace(/{}|{ }/gi,record.word)
    stateHandler("loading", true)
    createImagePromptGPT(backgroundPrompt, gptModel.gpt_model)
    .then(newPrompt=>{
      let onlyPrompt = newPrompt
      if(newPrompt[0] === `"`) {
        onlyPrompt = newPrompt.slice(1,-1)
      }
      const value = {
        id: record.dalle_id,
        WordExMaster_id: record.id,
        background_prompt: onlyPrompt
      }
      axios.post(`${backend}/contents/new_word/image/background_prompt`,{value})
      .then(res=>{
        const instance = {...record}
        instance.background_prompt = onlyPrompt
        instance.dalle_id = res.data.data
        stateHandler("sourceDataForRightBox", instance)
        stateHandler("rightBox", [true, instance])

        const newData = sourceData.slice(0)
        newData[id].statement_text = onlyPrompt
        promptDataChangeHandlerAll(newData)
      })
      .catch(err=>{
        console.log(err)
        Modal.error({
          title:"에러",
          okText:"확인",
          content:"서버 에러가 발생해서 프롬프트를 생성하지 못했습니다."
        })
      })
    })
    .catch(err=>{
      console.log(err)
      Modal.error({
        title:"에러",
        okText:"확인",
        content:"AI 에러가 발생해서 프롬프트를 생성하지 못했습니다."
      })
    })
    .finally(()=>{
      stateHandler("loading", false)
    })
  }

  useEffect(()=>{
    compareF()
  },[sourceData, finalPromptSentence])

  useEffect(()=>{
    setRightBoxID(rightBox[1].id)
    getSourceData()
    promptRef.current.resetFields()
  },[rightBox[1].id])

  useEffect(()=>{
    if(rightBoxId === rightBox[1].id) {
      const instance = sourceData.slice()
      for(let i=0;i<instance.length; i++) {
        if(instance[i].id === 1) {
          instance[i].statement_text = rightBox[1].meaning_prompt
          promptDataChangeHandlerAll(instance)
          break
        }
      }
    }
  },[rightBox[1].meaning_prompt])

  useEffect(()=>{
    if(rightBoxId === rightBox[1].id) {
      const instance = sourceData.slice()
      for(let i=0;i<instance.length; i++) {
        if(instance[i].id === 2) {
          instance[i].statement_text = rightBox[1].background_prompt
          promptDataChangeHandlerAll(instance)
          break
        }
      }
    }
  },[rightBox[1].background_prompt])

  return (
    <StyledSpace>
      <Modal
        destroyOnClose={true}
        width={"50%"}
        open={statements[0]}
        title="프롬프트 문장"
        onCancel={()=>{setStatements([false,null,{}])}}
        footer={null}
        
      >
        <div style={{background:"red", height:"400px"}}>
          <StyledTable
            className="pageTable"
            columns={columns}
            rowKey="id"
            dataSource={statements[2]}
            // loading={loading}
            pagination={false}
            scroll={{ x:100, y:"100%"}}
          />
        </div>
      </Modal>

      <Form layout="vertical" ref={promptRef}>
        <Form.Item
          name = "prompt_text"
          className="new-word-prompt"
          label={
            <div style={{display:"flex", justifyContent:"space-between", width:"100%"}}>
              <div>
                <span>최종 프롬프트 문장</span>
                <span style={{color:"red"}}>
                  {
                    compareCondition && isVariableCondition ? ""
                    : compareCondition && !isVariableCondition ? "(변수가 포함되어 있음)"
                    : !compareCondition && isVariableCondition ? "(위 조건과 상이함)"
                    : "(위 조건과 상이함, 변수가 포함되어 있음)"
                  }
                </span>
              </div>
              <Button size="small" onClick={finalPromptSentenceHandler}>문장 다시 생성</Button>
            </div>
          } 
          style={{margin: "0px 0px 10px"}}
        >
          <Input.TextArea 
            autoSize 
            value={finalPromptSentence}
            onChange={(e)=>setFinalPromptSentence(e.target.value)}
          ></Input.TextArea>
        </Form.Item>
      </Form>
      {getStructure()} 
    </StyledSpace>
  )
}

export default forwardRef(ImageTabRightPromptNewCondition)